/**
 * Load Optimizely functions
 */

(function (pmw, undefined) {

	pmw.loadOptimizelyPixel = function () {

		try {
			// Optimizely script URL format: https://cdn.optimizely.com/js/<project_id>.js
			const projectId = pmwDataLayer.pixels.optimizely.project_id;

			const script = document.createElement('script');
			script.type  = 'text/javascript';
			script.src   = 'https://cdn.optimizely.com/js/' + projectId + '.js';

			const firstScript = document.getElementsByTagName('script')[0];
			firstScript.parentNode.insertBefore(script, firstScript);

			pmwDataLayer.pixels.optimizely.loaded = true;

			pmw.console.log('Optimizely: pixel loaded');

		} catch (e) {
			console.error(e)
		}
	}

}(window.pmw = window.pmw || {}));
